import { render, staticRenderFns } from "./inspectionRecordDetail.vue?vue&type=template&id=e45cdcb2&scoped=true&"
import script from "./inspectionRecordDetail.vue?vue&type=script&lang=js&"
export * from "./inspectionRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectionRecordDetail.vue?vue&type=style&index=0&id=e45cdcb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45cdcb2",
  null
  
)

export default component.exports